// types/tracking-params.ts

// Literal tracking parameters (exact match)
export const TRACKING_PARAMS = [
  '_dssagcrid',
  '_dssftfiid',
  'ads_rl',
  'dclid',
  'dsaccountid',
  'dsaccounttype',
  'dscampaign',
  'dscampaignid',
  'dscarmkt',
  'dssagcrid',
  'dssftfiid',
  'fbclid',
  'gad_campaignid',
  'gad_source',
  'gbraid',
  'gclid',
  'gclsrc',
  'gcsrc',
  'gha2spon',
  'lid',
  'mc_cid',
  'mc_eid',
  'msclkid',
  'redirect',
  'sa',
  'sadid',
  'ttclid',
  'ttq',
  'utm_campaign',
  'utm_campaignid',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_source_platform',
  'utm_term',
  'ved',
] as const

// Regex patterns for dynamic tracking parameters
export const TRACKING_PARAMS_PATTERNS: RegExp[] = [
  /^ds_.+$/, // Matches ds_a_caid, ds_agid, ds_e_adid, ds_e_matchtype, etc.
]

export type TrackingParam = (typeof TRACKING_PARAMS)[number]

// Check if a param name matches any tracking param (literal or pattern)
export function isTrackingParam(param: string): boolean {
  if ((TRACKING_PARAMS as readonly string[]).includes(param)) return true
  return TRACKING_PARAMS_PATTERNS.some((pattern) => pattern.test(param))
}

// Extract all tracking params from URLSearchParams
export function extractTrackingParams(
  searchParams: URLSearchParams,
): Record<string, string> {
  const result: Record<string, string> = {}

  for (const [key, value] of searchParams.entries()) {
    if (isTrackingParam(key)) {
      result[key] = value
    }
  }

  return result
}
